let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("59e6p")).then(() => parcelRequire('dZptX'));